import { useState } from 'react';
import { Card, CardBody, CardExpandToggler } from '../../../components/card/card';
import Pie from '../../dashboard/Pie';
import Bar from '../../dashboard/Bar';
import Breadcrumb from '../../../components/Shared/Breadcrumb';

const PurchaseHome = () => {
  // const { t } = useTranslation();

  // بيانات المخططات
  const [purchaseData, setPurchaseData] = useState({
    title: 'حالة الفواتيـر ',

    labels: ['مدفوعة', 'غير مدفوعة'],

    series: [60, 40], // نسبة المدفوعة والمتأخرة
  });

  const monthlyPurchases = {
    title: ' قيمة المشتريات حسب الشهر',
    series: [
      {
        name: 'قيمة المشتريات',
        data: [20000, 30000, 25000, 40000, 35000, 50000, 30000, 45000, 40000, 55000, 60000, 50000],
      },
    ],
    categories: [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر',
    ],
  };

  // const purchaseTrend = {
  //   title: 'تتبع المشتريات بمرور الوقت',
  //   series: [
  //     {
  //       name: 'المشتريات',
  //       data: [10000, 20000, 15000, 30000, 25000, 35000, 30000, 40000, 45000, 50000, 55000, 60000],
  //     },
  //   ],
  //   categories: [
  //     'يناير',
  //     'فبراير',
  //     'مارس',
  //     'أبريل',
  //     'مايو',
  //     'يونيو',
  //     'يوليو',
  //     'أغسطس',
  //     'سبتمبر',
  //     'أكتوبر',
  //     'نوفمبر',
  //     'ديسمبر',
  //   ],
  // };

  const stackedPurchases = {
    title: 'قيمة المشتريات حسب الموردين والفئات',
    series: [
      { name: 'إلكترونيات', data: [10000, 15000, 12000] },
      { name: 'أغذية', data: [8000, 11000, 14000] },
      { name: 'أدوات مكتبية', data: [5000, 4000, 6000] },
    ],
    categories: ['شركة الكمال', 'شركة الريان', 'شركة السعيدة'],
  };

  const [topSuppliersData, setTopSuppliersData] = useState({
    title: 'الموردون الأكثر تعاملًا ',
    labels: ['شركة الكمال', 'شركة الريان', 'شركة السعيدة', 'شركة النور'], // أسماء الموردين

    series: [45000, 30000, 25000, 20000], // قيم المشتريات
  });

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: null,
          },
        ]}
      />
      <div className="row g-3 mb-3">
        <div className="col-12 col-md-6 col-lg-6">
          <Card className="d-flex justify-content-center align-items-center">
            <CardBody>
              <h3 className="text-theme mb-2">إجمالي المشتريات</h3>
              <p className="text-center fw-bold">{230093} ريال</p>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <Card className="d-flex justify-content-center align-items-center">
            <CardBody>
              <h3 className="text-theme mb-2">عدد الموردين</h3>
              <p className="text-center fw-bold">{12}</p>
            </CardBody>
          </Card>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-12 col-md-6 col-lg-4">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">{topSuppliersData.title}</span>
                <CardExpandToggler />
              </div>

              <Pie labels={topSuppliersData.labels} series={topSuppliersData.series} height={500} />
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 col-lg-8">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold"> {monthlyPurchases.title}</span>
                <CardExpandToggler />
              </div>

              <Bar
                categories={monthlyPurchases.categories}
                series={monthlyPurchases.series}
                height={400}
              />
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 col-lg-6">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">{stackedPurchases.title}</span>
                <CardExpandToggler />
              </div>

              <Bar
                categories={stackedPurchases.categories}
                series={stackedPurchases.series}
                height={520}
                isStacked={true}
              />
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 col-lg-6">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">{purchaseData.title} </span>
                <CardExpandToggler />
              </div>

              <Pie labels={purchaseData.labels} series={purchaseData.series} height={500} />
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PurchaseHome;
